import type { DownloadedFile } from '@/client/api/download.types'

import { ApiError } from '@maestro/data-layer'
import { theme } from '@maestro/local/theme'

const FILE_NAME_PATTERN = /filename="?([^";]+)"?/i

function getFileName(contentDisposition: string | null): string | undefined {
  return contentDisposition?.match(FILE_NAME_PATTERN)?.[1]?.trim() || undefined
}

export async function downloadFile(path: string): Promise<DownloadedFile> {
  const response = await fetch(path)

  if (response.redirected) {
    window.location.assign(response.url)
    throw new ApiError('Redirected', 0)
  }

  if (response.status === 401) {
    window.location.assign(`${theme().urls.logout}?reason=session_expired`)
    throw new ApiError('Not authenticated', 401)
  }

  if (!response.ok) {
    throw new ApiError(
      `API error: ${response.status} ${response.statusText}`,
      response.status
    )
  }

  return {
    blob: await response.blob(),
    fileName: getFileName(response.headers.get('Content-Disposition')),
  }
}
